import { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import "../../Styles/Pages/FarmerDetails.css";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Modal,
  Box,
  Button,
  Tooltip,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Topbar from "../../Layouts/Admin_layout/Admin_topbar";
import instance from "../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import "../../Styles/Pages/FarmerDetails.css";
import RoomIcon from "@mui/icons-material/Room";
import kml_icon from "../../Assets/kml_icon.svg"
import excel_icon from '../../Assets/excel_download.jpeg'
import { formatDate } from "../../utils/helper";

export default function FarmerDetails() {
  const { hash } = useParams();
  const navigate = useNavigate();
  const [farmer, setFarmer] = useState([]);
  const [farmerDetails, setFarmerDetails] = useState(null);
  const [updatedFarmerDetails, setUpdatedFarmerDetails] = useState(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [kmlFileUrl, setKmlFileUrl] = useState(null);
  const [imageToDelete, setImageToDelete] = useState(null);
  const date = new Date(farmerDetails?.date);
  const options = { year: "numeric", month: "numeric", day: "numeric" };


  const fetchFarmerDetails = async () => {
    try {
      const response = await instance.get(
        `/field/getfieldById?field_hash=${hash}`
      );
      setFarmer(response.data.farmer)
      setFarmerDetails(response.data.data);
      setUpdatedFarmerDetails(response.data.officerCheckout);
      if (response.data.data?.kml_file) {
        setKmlFileUrl(response.data.data.kml_file);
      }
      // console.log(response.data.data);
    } catch (err) {
      console.log(err);
    }
  };

  const handleDownloadKML = () => {
    if (kmlFileUrl) {
      const link = document.createElement("a");
      link.href = kmlFileUrl;
      link.setAttribute("download", "map.kml");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      console.error("KML file URL is not available");
    }
  };

  const handleDownloadExcel = () => {
    // --- Sheet 1: Basic Farmer & Field Details ---
    const basicData = [
      { Field: "Farmer Name", Value: farmer?.name || "" },
      { Field: "Mobile No", Value: farmer?.mobile_no || "" },
      { Field: "Email", Value: farmer?.email || "" },
      { Field: "Pincode", Value: farmerDetails?.pincode || "" },
      { Field: "Address", Value: farmerDetails?.address || "" },
      { Field: "District", Value: farmerDetails?.district_name || "" },
      { Field: "Mandal", Value: farmerDetails?.mandal_name || "" },
      { Field: "Village", Value: farmerDetails?.village_name || "" },
      { Field: "Cluster Name", Value: farmerDetails?.cluster_name || "" },
      { Field: "Sanction", Value: farmerDetails?.admit_sanction_given || "" },
      { Field: "Type of Customer", Value: farmerDetails?.type_of_customer || "" },
      { Field: "Ownership Type", Value: farmerDetails?.ownership_type || "" },
      { Field: "Area in Acres", Value: farmerDetails?.area_in_acres || "" },
      { Field: "Source of Water", Value: farmerDetails?.source_of_water || "" },
      { Field: "Borewell Count", Value: farmerDetails?.number_of_borewell || "" },
      { Field: "Electricity Availability", Value: farmerDetails?.electricity_availability || "" },
      { Field: "Registration Status", Value: farmerDetails?.registration_status || "" },
      { Field: "Registration Number", Value: farmerDetails?.registration_no || "" },
      { Field: "Drip Survey", Value: farmerDetails?.drip_survey || "" },
      { Field: "Drip DD Paid", Value: farmerDetails?.drip_dd_paid || "" },
      { Field: "Marking Status of Plants", Value: farmerDetails?.marking || "" },
      { Field: "Plant DD Paid", Value: farmerDetails?.plant_dd_paid || "" },
      { Field: "Plant DD Paid Date", Value: farmerDetails?.date ? new Date(farmerDetails.date).toLocaleDateString() : "" },
      { Field: "Plants Lifted", Value: farmerDetails?.plants_lifted || "" },
      { Field: "Plants Lifted Date", Value: farmerDetails?.date_of_plants_lifted ? new Date(farmerDetails.date_of_plants_lifted).toLocaleDateString() : "" },
      { Field: "Plantation Date", Value: farmerDetails?.plantation_date ? new Date(farmerDetails.plantation_date).toLocaleDateString() : "" },
      { Field: "Plantation Status", Value: farmerDetails?.plantation_status || "" },
      { Field: "Visit Date", Value: farmerDetails?.createdAt ? new Date(farmerDetails.createdAt).toLocaleDateString() : "" },
    ];

    // --- Sheet 2: Follow-up Visits ---
    const visitRows = (updatedFarmerDetails || []).map((item, index) => ({
      "Visit #": index + 1,
      "Visit Date": item?.createdAt ? new Date(item.createdAt).toLocaleDateString() : "N/A",
      "Plant Width": item?.plant_width || "",
      "Plant Length": item?.plant_length || "",
      "Number of Leafs": item?.number_of_leafs || "",
      "Description": item?.description || "",
      "Field Health": item?.field_health || "",
      "Inflorescence Observation": item?.inflorescence_observation || "",
      "FFB Production Date": item?.FFB_production_date ? new Date(item.FFB_production_date).toLocaleDateString() : "N/A",
      "Fertilization Remark": item?.fertilization_application_remark || "",
      "Irrigation Remarks": item?.irrigation_remarks || "",
      "Pest / Disease": item?.pest_remarks || "",
    }));

    const wb = XLSX.utils.book_new();

    const ws1 = XLSX.utils.json_to_sheet(basicData);
    ws1["!cols"] = [{ wch: 30 }, { wch: 40 }];
    XLSX.utils.book_append_sheet(wb, ws1, "Farmer Details");

    if (visitRows.length > 0) {
      const ws2 = XLSX.utils.json_to_sheet(visitRows);
      ws2["!cols"] = Object.keys(visitRows[0]).map(() => ({ wch: 25 }));
      XLSX.utils.book_append_sheet(wb, ws2, "Follow-up Visits");
    }

    XLSX.writeFile(wb, `farmer_${farmer?.name || hash}.xlsx`);
  };

  useEffect(() => {
    fetchFarmerDetails();
  }, [hash]);

  const handleDeleteConfirm = () => {
    setOpenDeleteModal(false);
  };

  const handleDeleteCancel = () => {
    setImageToDelete(null);
    setOpenDeleteModal(false);
  };

  const style = {
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    borderColor: "none",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
  };

  if (!farmerDetails) return <div>Loading...</div>;

  console.log(farmerDetails, "farmerDetails")
  return (
    <>
      <div style={{ padding: "20px 20px 0px 0px" }}>
        <Topbar />
      </div>
      <div style={{ padding: "20px 0px 0px 0px" }}>
        <div className="details-container">
          <div className="name-number">
            <div>
              <strong>Farmer Name :</strong> {farmer?.name}
            </div>
            <div>
              <strong>Mobile no :</strong> {farmer?.mobile_no}
            </div>
            <div>
              <strong>Email :</strong> {farmer?.email}
            </div>
            <div>
              <strong>Pincode :</strong> {farmerDetails?.pincode}
            </div>
            <div>
              <button
                onClick={() => navigate("/admin/Fields")}
                className="back-to-farmers"
              >
                Back
              </button>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              marginLeft: "10px",
              marginBottom: "10px",
              gap: '10px',
              alignItems: 'center',
            }}
          >
            <strong className="name-label">Address :</strong>{" "}
            {farmerDetails.address}{" "}
            <div style={{ marginLeft: '10px' }}>
              <Tooltip title="Track location">
                <a style={{ color: '#78c144', marginLeft: '5px' }}
                  href={`https://www.google.com/maps/place/${farmerDetails?.latitude}+${farmerDetails?.longitude}`}
                  target="blank"
                >
                  <RoomIcon />
                </a>
              </Tooltip>
            </div>

            <div style={{ display: "flex", gap: '30px', marginLeft: '20px' }}>
              {kmlFileUrl && (
                <Tooltip title="Download Xml File">
                  <img style={{ cursor: 'pointer', display: 'flex', justifyContent: 'center', marginTop: '-5px', alignItems: 'center', width: '24px' }} src={kml_icon} alt="kml_file" onClick={handleDownloadKML} />
                </Tooltip>
              )}
              <Tooltip title="Download Excel File">
                <img style={{ cursor: 'pointer', display: 'flex', justifyContent: 'center', marginTop: '-5px', alignItems: 'center', width: '30px' }} src={excel_icon} alt="excel_file" onClick={handleDownloadExcel} />
              </Tooltip>
            </div>
          </div>
          <div className="farmer-data-container">
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
                className="accordion-summary"
              >
                Date : {formatDate(farmerDetails.createdAt)} (Initial Visit)
              </AccordionSummary>
              <AccordionDetails className="accordion-details">
                <div className="section-header">Farmer Basic Details</div>
                <div>
                  <strong>District :</strong> {farmerDetails?.location_hash?.district_name}{" "}
                </div>
                <div>
                  <strong>Mandal :</strong> {farmerDetails?.location_hash?.name}{" "}
                </div>
                <div>
                  <strong>Village :</strong> {farmerDetails.village_name}{" "}
                </div>
                <div>
                  <strong>Cluster Name:</strong> {farmerDetails.cluster_name}{" "}
                </div>
                <div>
                  <strong>Sanction :</strong>{" "}
                  {farmerDetails.admit_sanction_given}{" "}
                </div>
                <div>
                  <strong>Type of Customer :</strong>{" "}
                  {farmerDetails.type_of_customer}{" "}
                </div>
                <div>
                  <strong>Ownership Type :</strong> {farmerDetails.ownership_type}{" "}
                </div>

                <div className="section-header">Land Details</div>
                <div>
                  <strong>Area in acres :</strong> {farmerDetails.area_in_acres}{" "}
                </div>
                <div>
                  <strong>Source Of Water:</strong> {farmerDetails.source_of_water}{" "}
                </div>
                {farmerDetails.source_of_water === "BoreWell" && (
                  <div>
                    <strong>Borewell Count :</strong>{" "}
                    {farmerDetails.number_of_borewell}{" "}
                  </div>
                )}
                <div>
                  <strong>Electricity Availability :</strong>{" "}
                  {farmerDetails.electricity_availability}{" "}
                </div>
                <div>
                  <strong>Registration Status:</strong>{" "}
                  {farmerDetails.registration_status}{" "}
                </div>
                {farmerDetails.registration_status === "Done" && (
                  <div>
                    <strong>Registration Number:</strong> {farmerDetails.registration_no}{" "}
                  </div>
                )}

                <div className="section-header">Land Status</div>
                <div>
                  <strong>Drip survey :</strong> {farmerDetails.drip_survey}{" "}
                </div>

                <div>
                  <strong>Drip dd Paid :</strong> {farmerDetails.drip_dd_paid}{" "}
                </div>


                <div>
                  <strong>Admit Sanction Given :</strong> {farmerDetails.admit_sanction_given}{" "}
                </div>
                <div>
                  <strong>Marking Status of plants:</strong> {farmerDetails.marking}{" "}
                </div>

                <div>
                  <strong>Plant DD Paid:</strong> {farmerDetails.plant_dd_paid}{" "}
                </div>
                {/* <div>
                  <strong>Plantation DD :</strong> {farmerDetails.plant_dd_paid}{" "}
                </div> */}
                <div>
                  <strong>Marking :</strong> {farmerDetails.marking}{" "}
                </div>

                <div>
                  <strong>Plant DD Paid Date:</strong> {formatDate(farmerDetails.date || "N/A")}{" "}
                </div>

                <div className="section-header">Plantation Details</div>
                <div>
                  <strong>Plants Lifted Date :</strong>{" "}
                  {farmerDetails?.date_of_plants_lifted ? (
                    <span>
                      {(() => {
                        const date = new Date(
                          farmerDetails.date_of_plants_lifted
                        );
                        const day = String(date.getDate()).padStart(2, "0");
                        const month = String(date.getMonth() + 1).padStart(
                          2,
                          "0"
                        );
                        const year = date.getFullYear();
                        return `${day}-${month}-${year}`;
                      })()}
                    </span>
                  ) : (
                    <span>N/A</span>
                  )}
                </div>
                <div>
                  <strong>Plants Lifted :</strong> {farmerDetails.plants_lifted}{" "}
                </div>
                <div>
                  <strong>Plantation Date :</strong>{" "}
                  {farmerDetails?.plantation_date ? (
                    <span>
                      {(() => {
                        const date = new Date(farmerDetails.plantation_date);
                        const day = String(date.getDate()).padStart(2, "0");
                        const month = String(date.getMonth() + 1).padStart(
                          2,
                          "0"
                        );
                        const year = date.getFullYear();
                        return `${day}-${month}-${year}`;
                      })()}
                    </span>
                  ) : (
                    <span>N/A</span>
                  )}
                </div>
                <div>
                  <strong>Plantation Status :</strong>{" "}
                  {farmerDetails.plantation_status}{" "}
                </div>



              </AccordionDetails>
              <div className="images-updated-container">
                <div>
                  <strong>Picture of Marking :</strong>
                  <div className="document">
                    <div className="image-container">
                      {farmerDetails.picture_of_marking ? <img loading="lazy"
                        className="document-images"
                        src={farmerDetails.picture_of_marking}
                        alt="documents"
                      /> : "N/A"}
                      {/* <DeleteIcon
                        className="delete-icon"
                        onClick={() =>
                          handleDeleteIconClick(
                            farmerDetails.picture_of_marking
                          )
                        }
                      /> */}
                    </div>
                  </div>
                </div>
                <div>
                  <strong>Picture of Plantation :</strong>
                  <div className="document">
                    <div className="image-container">
                      {farmerDetails.picture_of_plantation ? <img loading="lazy"
                        className="document-images"
                        src={farmerDetails.picture_of_plantation}
                        alt="plantation_images"
                      /> : "N/A"}
                      {/* <DeleteIcon
                        className="delete-icon"
                        onClick={() =>
                          handleDeleteIconClick(
                            farmerDetails.picture_of_plantation
                          )
                        }
                      /> */}
                    </div>
                  </div>
                </div>
                <div>
                  <strong>Documents</strong>
                  <div className="document">
                    <div className="image-container">
                      {farmerDetails.image_of_document.length
                        ? farmerDetails.image_of_document.map((item, index) => (
                          <div key={index}>
                            <img loading="lazy"
                              className="document-images"
                              src={item}
                              alt="document"
                            />
                            {/* <DeleteIcon
                                className="delete-icon"
                                onClick={() => handleDeleteIconClick()}
                              /> */}
                          </div>
                        ))
                        : "N/A"}
                    </div>
                  </div>
                </div>
              </div>
            </Accordion>
          </div>
          {updatedFarmerDetails?.length
            ? updatedFarmerDetails.map((item, index) => (
              <div className="farmer-data-container">
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                    className="accordion-summary"
                  >
                    {item?.createdAt ? (
                      <span>
                        {(() => {
                          const date = new Date(item?.createdAt);
                          const day = String(date.getDate()).padStart(2, "0");
                          const month = String(date.getMonth() + 1).padStart(2, "0");
                          const year = date.getFullYear();

                          const hours = date.getHours();
                          const minutes = String(date.getMinutes()).padStart(2, "0");

                          const ampm = hours >= 12 ? "PM" : "AM";
                          const formattedHours = hours % 12 || 12;

                          const formattedDate = `${day}-${month}-${year}`;
                          const formattedTime = `${formattedHours}:${minutes} ${ampm}`;

                          const isLatest = index === updatedFarmerDetails.length - 1;
                          return `Date : ${formattedDate} Time : ${formattedTime}${isLatest ? " (Latest Visit)" : ""}`;
                        })()}
                      </span>
                    ) : (
                      <span>Date: N/A</span>
                    )}
                  </AccordionSummary>
                  <AccordionDetails className="accordion-details">
                    <div className="section-header">Farmer Details</div>
                    <div>
                      <strong>Farmer Name :</strong> {farmer?.name}{" "}
                    </div>
                    <div>
                      <strong>Mandal :</strong> {farmerDetails?.mandal_name}{" "}
                    </div>
                    <div>
                      <strong>Address :</strong> {farmerDetails?.address}{" "}
                    </div>



                    <div className="section-header">Plant Details</div>
                    <div>
                      <strong>Plant Width :</strong> {item.plant_width}{" "}
                    </div>
                    <div>
                      <strong>Plant Length :</strong> {item.plant_length}{" "}
                    </div>
                    <div>
                      <strong>Number of Leafs :</strong> {item.number_of_leafs}{" "}
                    </div>
                    <div>
                      <strong>Description :</strong> {item.description}{" "}
                    </div>
                    <div>
                      <strong>Field Health :</strong> {item.field_health}{" "}
                    </div>
                    <div>
                      <strong>Inflorescence Observation :</strong> {item.inflorescence_observation}{" "}
                    </div>
                    <div>
                      <strong>FFD Production Date :</strong> {item.FFB_production_date ? formatDate(item.FFB_production_date) : "N/A"}{" "}
                    </div>

                    <div className="section-header">Remarks</div>
                    <div>
                      <strong>Fertilization Application :</strong>{" "}
                      {item.fertilization_application_remark}{" "}
                    </div>
                    <div>
                      <strong>Irrigation :</strong>{" "}
                      {item.irrigation_remarks}{" "}
                    </div>
                    <div>
                      <strong>Pest / Disease :</strong> {item.pest_remarks}{" "}
                    </div>

                  </AccordionDetails>
                  <div className="images-updated-container">

                    <div>
                      <strong>Selfie with Farmer </strong>{" "}
                      <div className="document">
                        <div className="image-container">
                          {item.selfie_with_field ? <img loading="lazy"
                            className="document-images"
                            width={100}
                            height={100}
                            src={item.selfie_with_field}
                            alt="selfie_of_farmer"
                          /> : "N/A"}
                        </div>
                      </div>
                    </div>

                    <div>
                      <strong>Field Pictures</strong>
                      <div className="document">
                        <div className="image-container">
                          {item.field_Pictures?.length
                            ? item.field_Pictures.map((item, index) => (
                              <div key={index}>
                                <img loading="lazy"
                                  className="document-images"
                                  width={100}
                                  height={100}
                                  src={item}
                                  alt="document"
                                />
                                {/* <DeleteIcon
                                    className="delete-icon"
                                    onClick={() => handleDeleteIconClick()}
                                  /> */}
                              </div>
                            ))
                            : "N/A"}
                        </div>
                      </div>
                    </div>

                    <div>
                      <strong>Pest / Disease Pictures </strong>{" "}
                      <div className="document">
                        <div className="image-container">
                          {item.pest_pictures ? <img loading="lazy"
                            className="document-images"
                            width={100}
                            height={100}
                            src={item.pest_pictures}
                            alt="pest_pictures"
                          /> : "N/A"}
                        </div>
                      </div>
                    </div>
                    <div>
                      <strong>Plant Pictures </strong>{" "}
                      <div className="document">
                        <div className="image-container">
                          {item.plant_picture?.length
                            ? item.plant_picture.map((item, index) => (
                              <div key={index}>
                                <img loading="lazy"
                                  className="document-images"
                                  width={100}
                                  height={100}
                                  src={item}
                                  alt="plant_picture"
                                />
                              </div>
                            ))
                            : "N/A"}
                        </div>
                      </div>
                    </div>


                  </div>
                </Accordion>
              </div>
            ))
            : null}
          <Modal
            open={openDeleteModal}
            onClose={handleDeleteCancel}
            aria-labelledby="delete-modal-title"
            aria-describedby="delete-modal-description"
          >
            <Box sx={style}>
              <div id="delete-modal-title">
                Do you want to delete this image ?
              </div>
              <div id="delete-modal-description">
                <Button
                  variant="contained"
                  className="yes"
                  onClick={handleDeleteConfirm}
                >
                  Yes
                </Button>
                <Button
                  variant="contained"
                  className="no"
                  onClick={handleDeleteCancel}
                >
                  No
                </Button>
              </div>
            </Box>
          </Modal>
        </div>
      </div>
    </>
  );
}
